import Col from "react-bootstrap/Col";
import Skeleton from "react-loading-skeleton";

const ProjectsLoadingSkeleton = () => {
  return (
    <>
      <Col xl={4} lg={6} md={6} sm={12}>
        <div className="project-card">
          <Skeleton height={260} />
          <h2 className="project-title">{<Skeleton width={300} />}</h2>
          <p className="project-date">{<Skeleton width={100} />}</p>
          <p className="project-description">{<Skeleton count={3} />}</p>
        </div>
      </Col>
      <Col xl={4} lg={6} md={6} sm={12}>
        <div className="project-card">
          <Skeleton height={260} />
          <h2 className="project-title">{<Skeleton width={300} />}</h2>
          <p className="project-date">{<Skeleton width={100} />}</p>
          <p className="project-description">{<Skeleton count={3} />}</p>
        </div>
      </Col>
      <Col xl={4} lg={6} md={6} sm={12}>
        <div className="project-card">
          <Skeleton height={260} />
          <h2 className="project-title">{<Skeleton width={300} />}</h2>
          <p className="project-date">{<Skeleton width={100} />}</p>
          <p className="project-description">{<Skeleton count={3} />}</p>
        </div>
      </Col>
    </>
  );
};

export default ProjectsLoadingSkeleton;
